import { IbillingState } from "@edp-store/state/billing.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const billingSelector = (state: IAppState) => state.billing;

export const getMonthlyInvoices = createSelector(billingSelector, (state: IbillingState) => state.monthlyInvoices);

export const getPaymentTab = createSelector(billingSelector, (state: IbillingState) => state.paymentTab);

export const getTariffFiles = createSelector(billingSelector, (state: IbillingState) => state.tariffFiles);
